export const fonts = {
  text: "Courier",
};

export const colors = {
  white: "#ffffff",
};

export const mediaQueries = {
  mobile: "@media screen and (max-width: 700px)",
  notMobile: "@media screen and (min-width: 701px)",
  notTablet: "@media screen and (min-width: 901px)",
  tablet: "@media screen and (max-width: 900px)",
};

export const sideMargins = {
  mobile: "20px",
  tablet: "40px",
  desktop: "300px"
}
